import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { logTrace } from "@/utils";
Vue.use(Router);

let startTime = Date.now();
let currentTime = null;

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes: [
    // {
    //   path: "*",
    //   name: "NotFind",
    //   component: () => import("@/views/notfind"),
    //   meta: {
    //     keepAlive: true,
    //     name: "首页",
    //   },
    // },
    {
      path: "/",
      name: "Home",
      component: () => import("@/views/home"),
      meta: {
        keepAlive: true,
        name: "首页",
      },
    },
    {
      path: "/user",
      name: "User",
      component: () => import("@/views/user"),
      meta: {
        keepAlive: false,
        name: "个人中心-我的",
      },
    },
    {
      path: "/bookSearch",
      name: "BookSearch",
      component: () => import("@/views/book-search"),
      meta: {
        keepAlive: true,
        name: "学术搜索页",
      },
    },
    {
      path: "/digitalReading",
      name: "DigitalReading",
      component: () => import("@/views/digital-reading"),
      meta: {
        keepAlive: false,
        name: "数字阅读列表页",
      },
    },
    {
      path: "/libIntroduce",
      name: "LibIntroduce",
      component: () => import("@/views/lib-introduce"),
      meta: {
        keepAlive: false,
        name: "图书馆介绍",
      },
    },
    {
      path: "/seatApply",
      name: "SeatApply",
      component: () => import("@/views/seat-apply"),
      meta: {
        keepAlive: false,
        name: "空间预约列表页",
      },
    },
    {
      path: "/activityDetail",
      name: "ActivityDetail",
      component: () => import("@/views/activity-detail"),
      meta: {
        keepAlive: false,
        name: "活动详情页",
      },
    },
    {
      path: "/myArticleDetail",
      name: "MyArticleDetail",
      component: () => import("@/views/my-article-detail"),
      meta: {
        keepAlive: false,
        name: "我的学术成果-论文详情页",
      },
    },
    {
      path: "/myBookDetail",
      name: "MyBookDetail",
      component: () => import("@/views/my-book-detail"),
      meta: {
        keepAlive: false,
        name: "我的学术成果-图书详情页",
      },
    },
    {
      path: "/activityNewest",
      name: "ActivityNewest",
      component: () => import("@/views/activity-newest"),
      meta: {
        keepAlive: true,
        name: "活动列表页",
      },
    },
    {
      path: "/noticeContent",
      name: "NoticeContent",
      component: () => import("@/views/notice-content"),
      meta: {
        keepAlive: false,
        name: "消息通知页",
      },
    },
    {
      path: "/bookBorrow",
      name: "BookBorrow",
      component: () => import("@/views/book-borrow"),
      meta: {
        keepAlive: false,
        name: "图书借阅",
      },
    },
    {
      path: "/scienceAchieve",
      name: "ScienceAchieve",
      component: () => import("@/views/science-achieve"),
      meta: {
        keepAlive: true,
        name: "我的学术成果",
      },
    },
    {
      path: "/myActivity",
      name: "MyActivity",
      component: () => import("@/views/my-activity"),
      meta: {
        keepAlive: false,
        name: "我的-活动收藏/预约",
      },
    },
    {
      path: "/myAlephBook",
      name: "MyAlephBook",
      component: () => import("@/views/my-aleph-book"),
      meta: {
        keepAlive: false,
        name: "我的-图书借阅/预约",
      },
    },
    {
      path: "/alephHoldDetail",
      name: "AlephHoldDetail",
      component: () => import("@/views/aleph-hold-detail"),
      meta: {
        keepAlive: false,
        name: "纸质书刊详情页",
      },
    },
    {
      path: "/newBookDetail",
      name: "NewBookDetail",
      component: () => import("@/views/new-book-detail"),
      meta: {
        keepAlive: false,
        name: "新书推荐详情页",
      },
    },
    {
      path: "/auth",
      name: "UisAuth",
      component: () => import("@/views/uis-auth"),
      meta: {
        keepAlive: false,
        name: "uis统一登录授权处理页",
      },
    },
    {
      path: "/screen",
      name: "Screen",
      component: () => import("@/views/screen"),
      meta: {
        keepAlive: false,
        name: "大屏活动扫码跳转页",
      },
    },
    {
      path: "/rankingChart",
      name: "RankingChart",
      component: () => import("@/views/ranking-chart"),
      meta: {
        keepAlive: false,
        name: "排行榜数据页",
      },
    },
    {
      path: "/wxauth",
      name: "WxAuth",
      component: () => import("@/views/wx-auth"),
      meta: {
        keepAlive: false,
        name: "微信授权处理页",
      },
    },
    {
      path: "/wxnotice",
      name: "WxNotice",
      component: () => import("@/views/wx-notice"),
      meta: {
        keepAlive: false,
        name: "微信消息模板详情获取",
      },
    },
    {
      path: "/bookdonation",
      name: "BookDonation",
      component: () => import("@/views/book-donation"),
      meta: {
        keepAlive: false,
        name: "我的捐赠列表",
      },
    },
    {
      path: "/integral",
      name: "Integral",
      component: () => import("@/views/integral"),
      meta: {
        keepAlive: false,
        name: "我的积分明细",
      },
    },
    {
      path: "/integralRule",
      name: "IntegralRule",
      component: () => import("@/views/integral-rule"),
      meta: {
        keepAlive: false,
        name: "积分规则",
      },
    },
    {
      path: "/integralReport",
      name: "IntegralReport",
      component: () => import("@/views/integral-report"),
      meta: {
        keepAlive: false,
        name: "积分统计报表",
      },
    },
    {
      path: "/activity-sign",
      name: "ActivitySign",
      component: () => import("@/views/activity-sign"),
      meta: {
        keepAlive: false,
        name: "活动扫码签到",
      },
    },
    {
      path: "/storage-box",
      name: "StorageBox",
      component: () => import("@/views/storage-box"),
      meta: {
        keepAlive: false,
        name: "暂存箱号图书列表",
      },
    },
    {
      path: "/wx-follow",
      name: "WxFollow",
      component: () => import("@/views/wx-follow"),
      meta: {
        keepAlive: false,
        name: "微信公众号关注",
      },
    },
    {
      path: "/500",
      name: "500",
      component: () => import("@/views/500"),
      meta: {
        name: "服务器异常",
        keepAlive: false,
      },
    },
  ],
});
if (process.env.NODE_ENV === "production") {
  if (process.env.VUE_APP_IS_WXAUTH === "Y") {
    const noAuthUrlList = [
      "/auth",
      "/500",
      "/noticeContent",
      "/wxauth",
      "/wxnotice",
      "/storage-box",
      "/wx-follow",
    ];
    router.beforeEach((to, from, next) => {
      if (to.path == "/auth" || to.path == "/wxauth") {
        document.title = "";
      } else {
        document.title = process.env.VUE_APP_HTML_TITLE;
      }
      if (noAuthUrlList.includes(to.path)) {
        handleLogTrace(from, to);
        next();
      } else {
        if (!store.getters.openId) {
          window.location.replace(
            `${
              process.env.VUE_APP_WX_AUTH_URL
            }&state=${window.encodeURIComponent(to.fullPath)}#wechat_redirect`
          );
          return;
        } else {
          handleLogTrace(from, to);
          next();
        }
      }
    });
  } else {
    router.beforeEach((to, from, next) => {
      if (to.path == "/auth" || to.path == "/wxauth") {
        document.title = "";
      } else {
        document.title = process.env.VUE_APP_HTML_TITLE;
      }
      handleLogTrace(from, to);
      next();
    });
  }
}

const handleLogTrace = (from, to) => {
  if (to) {
    currentTime = Date.now();
    const holdTime = currentTime - startTime;
    logTrace({
      holdTime,
      prefixUrl: from ? from.path : "/",
      prefixUrlName: from ? from.meta.name || "首页" : "首页",
      requestUrl: to ? to.path : "/",
      rquestUrlName: to ? to.meta.name || "首页" : "首页",
      actionType: "page",
      actionTypeCode: "1",
      actionTypeDesc: "页面跳转",
    });
    startTime = Date.now();
  }
};

export default router;
